import request from './AxiosRequest';

const edit = params =>
	request({
		url: `/Services/MainService.svc/json/SaveLike`,
		method: 'post',
		data: { like: params }
	});

const SaveLike = {
	edit
};

export default SaveLike;